import React, { useEffect, useState } from "react";
import "./Contact.css";
import { FiInstagram } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { ref, set } from "firebase/database";
import { db } from "../../firebaseConfig";
import {uid} from "uid";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Contact() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mail, setMail] = useState("");

    function writeUserData() {
        if (name && email && mail) {
            const uuid = uid();
            set(ref(db, `/${uuid}`), {
                name: name,
                email: email,
                mail: mail,
            });
            toast.success('Your message have been sent successfully!');
            resetUserData()
        } else {
            toast.error('Please fill in all the required fields!');
        }
    }

    function resetUserData() {
        setName("");
        setEmail("");
        setMail("");
    }

    return (
        <section id="contact">
            <div id="contact-container">
                <div className="contact-headline">
                    <p> Keep in Touch </p>
                    <h1> Contact Me </h1>
                </div>

                <div className="contact-content">
                    <div className="contact-box">
                        <div className="contact-box-container">
                            <div className="contact-box-items">
                                <label htmlFor="name"> Name: </label>
                                <input
                                    onChange={(e) => {
                                        setName(e.target.value);
                                    }}
                                    type="text"
                                    // name="name"
                                    id="name"
                                    className="input"
                                    required
                                    value={name}
                                />
                            </div>

                            <div className="contact-box-items">
                                <label htmlFor="email"> Email: </label>
                                <input
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                    }}
                                    type="email"
                                    // name="email"
                                    id="email"
                                    className="input"
                                    required
                                    value={email}
                                />
                            </div>

                            <div className="contact-box-items">
                                <label htmlFor="messages"> Messages: </label>
                                <input
                                    onChange={(e) => {
                                        setMail(e.target.value);
                                    }}
                                    type="text"
                                    // name="messages"
                                    autoComplete="off"
                                    id="messages"
                                    className="input"
                                    required
                                    value={mail}
                                />
                            </div>

                            <div className="contact-box-button">
                                <button onClick={resetUserData}>
                                    {" "}
                                    Cancel{" "}
                                </button>
                                <button onClick={writeUserData}>
                                    {" "}
                                    Submit{" "}
                                </button>
                            </div>

                            <ToastContainer/>   
                        </div>
                    </div>

                    <div className="contact-media">
                        <div className="contact-cards">
                            <a href="mailto:owenmarscel@gmail.com" target="__blank">
                                <div className="contact-cards-logo">
                                    <span>
                                        <HiOutlineMail />
                                    </span>
                                </div>

                                <div className="contact-cards-text">
                                    <h3> Email </h3>
                                    <h5> owenmarscel@gmail.com </h5>
                                    <a href="mailto:owenmarscel@gmail.com" target="__blank"> Send a message </a>
                                </div>
                            </a>
                        </div>

                        <div className="contact-cards">
                            <a href="https://api.whatsapp.com/send?phone=628973353739" target="__blank">
                                <div className="contact-cards-logo">
                                    <span>
                                        <FaWhatsapp />
                                    </span>
                                </div>

                                <div className="contact-cards-text">
                                    <h3> Whatsapp </h3>
                                    <h5> (+62) 897-3353-739 </h5>
                                    <a href="https://api.whatsapp.com/send?phone=628973353739" target="__blank"> Send a message </a>
                                </div>
                            </a>
                        </div>

                        <div className="contact-cards">
                            <a href="https://instagram.com/owenmarss" target="__blank">
                                <div className="contact-cards-logo">
                                    <span>
                                        <FiInstagram />
                                    </span>
                                </div>

                                <div className="contact-cards-text">
                                    <h3> Instagram </h3>
                                    <h5> @owenmarss </h5>
                                    <a href="https://instagram.com/owenmarss" target="__blank"> Send a message </a>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
